<script setup lang="ts">
    import { useAppStore } from '#imports';

    /* Store variables */
    const { isMobile } = storeToRefs(useAppStore());
</script>

<template>
    <v-layout>
        <SiteAppBar />
        <div class="w-100">
            <!--<SiteNavDrawer />-->
            <v-main class="w-100">
                <v-container
                    style="margin-bottom: 128px;"
                    fluid>
                    <slot></slot>
                </v-container>
            </v-main>
        </div>
    </v-layout>
</template>